import { render, staticRenderFns } from "./TheoryCreateCard.vue?vue&type=template&id=7c0eca68&"
import script from "./TheoryCreateCard.vue?vue&type=script&lang=ts&"
export * from "./TheoryCreateCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports